import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogCategoryTitleInterface } from 'common/types/entities/BlogCategoryTitleInterface'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createBlogCategoryTitle(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
) {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.BlogCategoryTitle,
      parentId,
      masterBlockId,
    ),
    fontSize: 42,
    color: 'rgba(0, 0, 0, 1)',
    mobileFontSize: 12,
    textAlign: 'center',
  } as BlogCategoryTitleInterface
}
